// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"7f9c1b87","787":"cce27dcd","898":"10748c72"}[chunkId] + ".chunk.js";
};